exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-vxe-toolbar-collapsed [data-collapse] {\n  display: none;\n}\n.j-vxe-tool-button.div .ant-btn {\n  margin-right: 8px;\n}\n", ""]);

// exports
